import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

/* Retired mock path (kept for reference; do not wire back without product sign-off):
import { REPORTS_CANCELLED_DATA } from "../_mock/mock";
const headLabel = [
  { id: 1, label: "AR Confirmed Date", value: "arConfirmedDate" },
  { id: 2, label: "AD 11 Rate_Cout 1 ", value: "rateCout" },
];
const tableData = [
  { arConfirmedDate: "2024-02-25", rateCout: 5 },
  { arConfirmedDate: "2024-02-26", rateCout: 10 },
  { arConfirmedDate: "2024-02-27", rateCout: 7 },
  { arConfirmedDate: "2024-02-28", rateCout: 12 },
  { arConfirmedDate: "2024-02-29", rateCout: 3 },
];
*/

/** Columns aligned with `getBedOccupancyReport` → `data.tableData` (reports.analytics.service). */
const headLabel = [
  { id: 1, label: "SNO", value: "sno" },
  { id: 2, label: "Patient UHID", value: "patientUhid" },
  { id: 3, label: "Patient Name", value: "patientName" },
  { id: 4, label: "Ward", value: "ward" },
  { id: 5, label: "Bed", value: "bed" },
  { id: 6, label: "Visit No", value: "visitNo" },
  { id: 7, label: "Status", value: "status" },
];

export default function ReportsBedOccupancyTable({ tableData = [] }) {
  const rows = Array.isArray(tableData) ? tableData : [];

  return (
    <TableContainer component={Paper}>
      <Table aria-label="bed occupancy detail table" sx={{ minWidth: 800 }}>
        <TableHead
          sx={{
            backgroundColor: "#f5f5f5",
            "& th": { fontWeight: "bold" },
          }}
        >
          <TableRow>
            {headLabel?.map((option) => (
              <TableCell
                key={option?.id}
                sx={{ textAlign: option?.align || "left" }}
              >
                {option?.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={headLabel.length} sx={{ py: 4, textAlign: "center" }}>
                <Typography color="text.secondary">
                  No occupancy rows for this date. Run search after choosing template and confirmed date.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, idx) => (
              <TableRow key={row?._id ?? row?.visitNo ?? row?.sno ?? idx}>
                {headLabel?.map((column) => (
                  <TableCell key={column?.id}>
                    {column?.value === "active"
                      ? row?.[column?.value]
                        ? "Active"
                        : "Inactive"
                      : row?.[column?.value] ?? "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
